import { CursorPaginationResult } from "@/types/CursorPaginationResult";
import { SangjoReviewTag } from "@/types/reviewType";
import { Axios } from "@/utils/axios";

export interface Review {
  id: number;
  funeral_director: {
    id: number;
    name: string;
  };
  headline: string;
  content: string;
  good?: string;
  score: number;
  created_at: string;
  sangjo_type: string;
  parlor: string;
  charge: number | null;
  user: {
    age_and_gender: string;
    nickname: string;
    picture?: string;
  };
  isCurrent?: boolean;
}

export interface NewReview {
  id: number;
  sangjos: {
    id: number;
    name: string;
  };
  headline: string;
  good: string;
  bad?: string;
  process: number;
  sincerity: number;
  price: number;
  additional_charge: number;
  score: number;
  created_at: string;
  sangjo_type: string;
  parlor: string;
  charge: number | null;
  user: {
    age_and_gender: string;
    nickname: string;
    picture?: string;
  };
  isCurrent?: boolean;
  tags?: SangjoReviewTag[];
  funeral_director?: string;
  district?: string;
}

export const getReviews = (params: { sangjo?: number[]; service_type?: string[] } = {}) => {
  const sangjo = params.sangjo ? params.sangjo.join(",") : undefined;
  const service_type = params.service_type ? params.service_type.join(",") : undefined;

  return async ({ pageParam = "" }) => {
    const page = pageParam ? new URL(pageParam).searchParams.get("page") : 1;

    const { data } = await Axios.get<CursorPaginationResult<NewReview>>("/sangjo_reviews", {
      params: {
        sangjo,
        service_type,
        page,
      },
    });
    return data;
  };
};

export const getPaginationReviews = async (page: number, tag?: string) => {
  const { data } = await Axios.get<CursorPaginationResult<NewReview>>(`/sangjo_reviews`, {
    params: {
      page,
      tag,
    },
  });
  return data;
};

export const getBestReviews = async () => {
  const { data } = await Axios.get<CursorPaginationResult<NewReview>>(
    `/sangjo_reviews/?is_best_review=True`,
  );
  return data;
};
